window.$ = window.jQuery = jQuery;
import 'bootstrap';
import Map from './classes/Map';
import Translation from './classes/Translations';
import FixedHeader from './classes/FixedHeader';
import SideNav from './classes/SideNav';
import HoverImageText from './classes/HoverImageText';


// Without this import, 'dist/main.css' will not be generated on build.
import '../scss/main.scss';
class CivicThemeIndex {
  /**
   * Functions here will be called when
   * the document is  ready.
   */
  initOnDocumentLoad() {
    this.instantiateClasses(FixedHeader, 'header.header-fixed');
  }

  /**
   * Functions here will be called when the
   * window is fully loaded. This is the final
   * step in the render process and ensures that 
   * all elements are now in the DOM.
   */
  initOnWindowLoad() {
    this.instantiateClasses(Map, '#map');
    this.instantiateClasses(SideNav, '.colleft');
    this.instantiateClasses(HoverImageText, '.paragraph--type--information-card .image-tile')
  }

  initOnWindowLoadTranslations() {
    this.instantiateClasses(Translation, '#block-languageswitcher');
  }

  /**
   * 
   * @param {Object} ClassName - Class constructor
   * @param {string} selector - The query selector associated with this class
   * 
   * This function instantiates classes and calls their init method.
   * 
   * If a selector is provided, the class will be instantiated once
   * for every element found in the DOM. If no elements are found,
   * then no classes will be instantiated. This helps prevent
   * unnecessary JavaScript from being added to the page.
   */
  instantiateClasses(ClassName, selector) {
    if (!selector) {
      new ClassName();
    } else {
      const elements = document.querySelectorAll(selector);
      elements.forEach((element, index) => {
        var classInstance = new ClassName(element, index);
        if (typeof classInstance.init === 'function') {
          classInstance.init();
        }
      });
    }
  }
}

// Polyfill for forEach method
(function () {
  if (typeof NodeList.prototype.forEach === "function")
    return false;
  NodeList.prototype.forEach = Array.prototype.forEach;
})();
/** 
 * Instatiate the CivicThemeIndex Class
 * 
 * This is the recommended format to add JavaScript in Drupal.
 * https://www.drupal.org/docs/8/api/javascript-api/javascript-api-overview
 */
(function ($, Drupal) {
  var index = null;
  Drupal.behaviors.civicTheme = {
    attach: function (context) {
      if ($(".view-utm-map").length) {
        $('html').addClass('is-map-with-footer');
      }
      if (context === document) {
        index = new CivicThemeIndex();
        index.initOnDocumentLoad();
        $(window).on('load', function () {
          index.initOnWindowLoad();
          setTimeout(
            function () {
              index.initOnWindowLoadTranslations();
            }, 1000);
        });
      }

      //Internal page header preview
      var breads = document.getElementsByClassName('head-internal');
      var midSection = document.getElementsByClassName('field-name--field-sections-internal-page');
      if (breads && midSection[0]) {
        midSection[0].prepend(breads[0]);
        breads[0].style.display = "block";
      }

      //Page Icons Hover
      $(".img-main").hover(function () {
        if (this.parentElement) {
          var title = this.parentElement.parentElement.querySelector(".field-name--field-link");
          if (title) {
            title.style.fontWeight = "bolder";
          }
        }
      }, function () {
        if (this.parentElement) {
          var title = this.parentElement.parentElement.querySelector(".field-name--field-link");
          if (title) {
            title.style.fontWeight = "500";
          }
        }
      });

      //Side Menu links remove space
      $('.submenu-links').find('a').each(function () {
        if ($(this).attr('href')) {
          $(this).attr('href', decodeURI($(this).attr('href')));
        }
      });

      //Information Cards Section
      var internalPage = document.getElementsByClassName('page-node-type-internal-page');
      if (internalPage) {
        var basicSection = document.querySelectorAll(".field-type--text-long p");
        var basicSectionHeaders = document.querySelectorAll(".field-type--text-long h1, .field-type--text-long h2, .field-type--text-long h3, .field-type--text-long h4, .field-type--text-long h5, .field-type--text-long h6");

        if (basicSectionHeaders) {
          Array.prototype.forEach.call(basicSectionHeaders, function (section) {
            Array.prototype.forEach.call(section.querySelectorAll("span"), function (elem) {
              elem.style.removeProperty('font-family');
              elem.style.fontFamily = "'Montserrat', sans-serif !important;";
            });
          });
        }


        if (basicSection) {
          Array.prototype.forEach.call(basicSection, function (section) {
            var child = section.childElementCount;
            if (child) {
              Array.prototype.forEach.call(section.querySelectorAll(":scope > span"), function (elem) {
                elem.style.removeProperty('font-family');
                elem.style.fontFamily = "'Montserrat', sans-serif !important;";
              });
            }
          });
        }

        var infoCard = document.querySelectorAll(".field-name--field-card");
        if (infoCard) {
          Array.prototype.forEach.call(infoCard, function (card) {
            var selectionCount = card.childElementCount;
            if (selectionCount) {
              if (selectionCount >= 3) {
                Array.prototype.forEach.call(card.querySelectorAll(":scope > div"), function (el) {
                  if ($(window).width() <= 650) {
                    el.style.flexBasis = "100%";
                  } else {
                    el.style.flexBasis = "30%";
                  }
                });
              } else {
                Array.prototype.forEach.call(card.querySelectorAll(":scope > div"), function (el) {
                  if ($(window).width() <= 650) {
                    el.style.flexBasis = "100%";
                  } else {
                    el.style.flexBasis = "45%";
                  }
                });
              }
            }
          });
        }
      }


      //Search bars
      var search = document.getElementsByClassName('header-search-form');
      var mainSearch = document.getElementsByClassName('main-search');
      var base_url = window.location.origin;
      var langCode = drupalSettings.path.currentLanguage;
      if (langCode != 'en') {
        if (search) {
          for (let item of search) {
            item.action = base_url + '/' + langCode + '/search/node';
          }
        }
        if (mainSearch) {
          for (let itemMain of mainSearch) {
            itemMain.action = base_url + '/' + langCode + '/search/node';
          }
        }
      }

      if ($(window).width() <= 1000) {

        var item_width = $('.paragraph--type--embedded-blocks-section.bg-big-light-blue #block-views-block-featured-content-block-1 .news .news-items .views-row').width();
        var items_count = 0;
        $('.paragraph--type--embedded-blocks-section.bg-big-light-blue #block-views-block-featured-content-block-1 .news .news-items .views-row').each(function () {
          items_count++;
        });
        $('.paragraph--type--embedded-blocks-section.bg-big-light-blue #block-views-block-featured-content-block-1 .news .news-items').width(item_width * items_count);
      }

    }



  };
})(jQuery, Drupal);


